import * as React from 'react';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ILocalization } from 'bernie-l10n';
import { SWPToggle } from 'components/common/swp-toggle';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkIcon } from 'uitk-react-icons';
import { ResultTitleViewModel } from 'models';
import { ClickTracker } from 'bernie-analytics';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
const Tag = 'a';
const LinkTracked = ClickTracker(Tag);

export interface ResultsTitleProps {
  isLoading: boolean;
  resultCountMessage?: ResultTitleViewModel;
  loyaltyMessagingModel?: any;
  l10n?: ILocalization;
  searchCriteria: SearchCriteriaModel;
}

export const ResultsTitle: React.FunctionComponent<ResultsTitleProps> = ({
  isLoading,
  resultCountMessage,
  loyaltyMessagingModel,
  l10n,
  searchCriteria
}) => {
  const { header, separator, subHeader, link, icon } = resultCountMessage;
  const resultTitleClassName = 'uitk-type-200 pwa-theme--grey-700 tools__title uitk-type-center uitk-type-bold';
  const linkName = 'Sort Disclaimer';
  const rfrr = 'HOT.HSR.RecommendedSort.FAQlink';

  return (
    <header className="tools__summary">
      {isLoading && <p className={resultTitleClassName}>{l10n.formatText('hotels.searchResults.loadingMessage.text')}</p>}
      {!isLoading &&
        (header || subHeader) && (
          <p className={resultTitleClassName}>
            <AbacusExperiment name="PWA_Remove_Property_count_at_top_of_HSR">
              <AbacusControl>
                <>
                  {header} {subHeader && header && separator}
                </>
              </AbacusControl>
              <AbacusVariant bucket={1} />
            </AbacusExperiment>

            {subHeader && (
              <UitkMoreInfoTrigger className="all-l-padding-one link__title" type={200}>
                <LinkTracked href={link} linkName={linkName} rfrr={rfrr} target="_blank">
                  {subHeader}
                  {icon && <UitkIcon name={icon} />}
                </LinkTracked>
              </UitkMoreInfoTrigger>
            )}
          </p>
        )}
      <SWPToggle model={loyaltyMessagingModel} searchCriteria={searchCriteria} />
    </header>
  );
};
